import './App.scss';
import React, { useMemo, useCallback, useEffect, useState, useRef } from 'react';
import App from './App';
import Login from './Login';
import { User, HOST } from './types';
import { xhr, funBackground } from './util';



export default function Front() {
    let [loading, setLoading] = useState(true);
    let [user, setUser] = useState<User>({} as User);
    let [authenticated, setAuthenticated] = useState(false);
    let colorStops = 1000;

    const [frontStyle, setFrontStyle] = useState<Record<string, any>>({});
    const [h1Style, setH1Style] = useState<Record<string, any>>({});


    useEffect(() => {
        const [styleObj, h1StyleObj, c, d] = funBackground(500);

        setFrontStyle(d);
        setH1Style(h1StyleObj);
        getUser()
    }, []);

    console.log('Getting a user: HOST ' + '/get-user')

    const getUser = useCallback(() => {
        xhr({
            method: 'GET',
            url: HOST + '/get-user',
            isOnPageLoad: true
        }).then(res => {
            setTimeout(() => {
                setLoading(false);
                if (!res.error) {
                    setUser(res.user);
                    setAuthenticated(true);
                }
            }, 1)
        });
    }, []);
    
    return (
        loading ? <div id="Front" style={frontStyle}>
            <section>

                <h1 style={h1Style}>fiance-calendar</h1>

            </section>
        </div> : (
            user.id ? <App user={user} setUser={setUser} /> : <Login setUser={setUser} />
        )
    );
}